import './dashboardpanel.css'
import React from 'react'
import { Route } from 'react-router-dom'
import Protected from '../../protected'
import Header from '../header/header'
import Dashboard from './dashboard/dashboard'
import Driver from './driver/driver'
import Load from './laod/load'
import Broker from './broker/broker'
import AddLoad from './laod/addload/addload'
import LoadDetail from './laod/loaddetail/loaddetail'
import Faq from './faq/faq'
import ProfilePanel from './profilepanel/profilepanel'
import Plans from './plans/plans'
import PermitBook from "./permit_book/permit_book";
function DashboardPanel() {
    return (
        <div className='dashboard'>
            <Header />
            <div className='dashboard-wrapper'>
                <div className='dashboard-cont'>
                    <Protected path="/dashboard" component={Dashboard} />
                    <Protected path="/drivers" component={Driver} />
                    <Protected path="/loads" component={Load} />
                    <Protected path="/add-load" component={AddLoad} />
                    {/* <Protected path="/load-detail" component={LoadDetail}/>*/}
                    <Protected path="/brokers" component={Broker} />
                    <Protected path="/permit-book" component={PermitBook} />
                    <Protected path="/payroll" component={LoadDetail} />
                    <Protected path="/faq" component={Faq} />
                    <Protected path="/profile" component={ProfilePanel} />
                    <Protected path="/account-plans" component={Plans} />
                </div>
            </div>
        </div>
    )
}

export default DashboardPanel